import React from "react";
import Image from "next/image";
import Colors from "../../constants/Colors";
import {deviceMax} from "../../../styles/device";
import styled from "styled-components";

const WhyPinkBlinds = () => {
    return (
        <WhyPinkBlindsWrapper id={"why-pink-blind-container"}>
            <div className="why-pink-blind-container">
                <div className="why-pink-blind-img">
                    <Image loading={'lazy'} width={2406}
                           height={1030}
                           sizes={'100vw'}
                           style={{width: '100%', height: 'auto'}}
                           src={`/next/assets/images/neden-pembe-panjur.png`}
                           alt={'Pembe Panjur Hakkımızda'} title={'Pembe Panjur Hakkımızda'}
                           className={'desktop-img'}
                    />
                    <Image loading={'lazy'} width={780}
                           height={940}
                           sizes={'100vw'}
                           style={{width: '100%', height: 'auto'}}
                           src={`/next/assets/images/neden-pembe-panjur-mobile.png`}
                           alt={'Pembe Panjur Hakkımızda'} title={'Pembe Panjur Hakkımızda'}
                           className={'mobile-img'}
                    />
                </div>
                <div className="why-pink-blind-wrapper">
                    <h2>
                        Neden Pembe Panjur
                    </h2>
                    <div className="why-pink-blind-content">
                        <div className="why-pink-blind-column">
                            <h3>
                                Her ay 90.000 yeni üye
                            </h3>
                            <p>
                                Pembe Panjur her ay kazandığı 90.000 üye ve toplamda 10 milyonun üzerinde üyeyle,
                                başarılı bir evlilik sitesidir.
                            </p>
                        </div>
                        <div className="why-pink-blind-column">
                            <h3>
                                %35 kadın üye oranı
                            </h3>
                            <p>
                                Pembe Panjur'un yarattığı güven iklimi kadın kullanıcılara büyük rahatlık sağlamaktadır.
                                Bu nedenle üyelerimizin üçte birinden fazlası kadınlardan oluşur.
                            </p>
                        </div>
                        <div className="why-pink-blind-column">
                            <h3>
                                1.5 milyon üzerinde mesaj
                            </h3>
                            <p>
                                Pembe Panjur üyeleri arasındaki ortalama mesaj sayısı günlük 1.5 milyonun üzerindedir.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </WhyPinkBlindsWrapper>
    )
}


const WhyPinkBlindsWrapper = styled.div`
  position: relative;
  margin-left: 20px;
  margin-right: 20px;

  > .why-pink-blind-container {
    position: relative;
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 0 auto;
    background: ${Colors.white};
    border-radius: 6px;

    > .why-pink-blind-img {
      position: relative;

      > img {
        width: 100%;
        height: auto;
        object-fit: contain;

        &.desktop-img {
          display: block;

          @media ${deviceMax.tablet} {
            display: none;
          }
        }

        &.mobile-img {
          display: none;

          @media ${deviceMax.tablet} {
            display: block;
          }
        }
      }

    }

    > .why-pink-blind-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 0 56px 40px;
      background: ${Colors.white};

      @media ${deviceMax.tablet} {
        padding-left: 35px;
        padding-right: 35px;
      }

      > h2 {
        font-family: 'Manrope', sans-serif;
        font-weight: 800;
        font-size: 18px;
        line-height: 55px;
        letter-spacing: 0;
        text-transform: uppercase;
        color: ${Colors.brandColor};
        margin: 10px 0;

        @media ${deviceMax.tablet} {
          width: 100%;
          color: ${Colors.blackColor};
          text-align: center;
          line-height: 30px;
          margin-top: 30px;
          margin-bottom: 30px;
        }
      }

      > .why-pink-blind-content {
        position: relative;
        display: flex;
        flex-direction: row;

        @media ${deviceMax.tablet} {
          flex-direction: column;
        }

        > .why-pink-blind-column {
          position: relative;
          display: flex;
          flex-direction: column;
          margin-right: 60px;

          &:last-child {
            margin-right: 0;
          }

          @media ${deviceMax.tablet} {
            align-items: center;
            justify-content: center;
            margin-bottom: 30px;
            margin-right: 0;
          }

          > h3 {
            font-family: 'Manrope', sans-serif;
            font-weight: 800;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0;
            color: ${Colors.blackColor};
            margin-top: 0;
          }

          > p {
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 18px;
            line-height: 30px;
            letter-spacing: 0;
            color: ${Colors.blackColor};
            margin-top: 0;
            margin-bottom: 0;

            @media ${deviceMax.tablet} {
              text-align: center;
            }
          }
        }
      }


    }
  }
`;


export default WhyPinkBlinds;
